// Written in this round about way for babel-transform-imports
import Route from "react-router/es/Route";

export default Route;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react-router-dom/es/Route.js
// module id = 360
// module chunks = 4 5 6